import { TOOLS_IDS } from './constants';

/**
 * Replace image source while keeping placement (x, y, width, height, rotation, opacity).
 *
 * @param {object} annotation
 * @param {HTMLImageElement} loadedImg
 * @param {string} [imageSrc] data URL or blob URL for persistence
 */
const replaceImageAnnotationSource = (annotation, loadedImg, imageSrc) => {
  if (annotation?.name !== TOOLS_IDS.IMAGE || !loadedImg) {
    return null;
  }

  const currentWidth = annotation.width || loadedImg.width;
  const currentHeight = annotation.height || loadedImg.height;
  const src =
    imageSrc ||
    (typeof loadedImg.src === 'string' ? loadedImg.src : undefined);

  return {
    ...annotation,
    image: src || loadedImg,
    width: currentWidth,
    height: currentHeight,
  };
};

export default replaceImageAnnotationSource;
